import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import Login from "@/pages/auth/login.vue";
import Index from "@/pages/main/index.vue";
import BodyprintEditView from "@/pages/bodyprint/bodyprint-edit-view.vue";
import BodyprintCheckView from "@/pages/bodyprint/bodyprint-check-view.vue";
import BodyprintQueueView from "@/pages/bodyprint/bodyprint-queue-view.vue";
import BodyprintDeclinedView from "@/pages/bodyprint/bodyprint-declined-view.vue";
import BlurQueueView from "@/pages/blur/blur-queue-view.vue";
import BlurEditView from "@/pages/blur/blur-edit-view.vue";
import ProductionListView from "@/pages/production/production-list-view.vue";
import ProductionOrderCheckView from "@/pages/production/production-order-check-view.vue";
import ProductionOrderEditView from "@/pages/production/production-order-edit-view.vue";
import Settings from "@/pages/settings/settings.vue";

Vue.use(VueRouter);

export const ROUTE_HEALTH = "healthz";
export const ROUTE_LOGIN = "login";
export const ROUTE_INDEX = "index";
export const ROUTE_BODYPRINT_QUEUE = "bodyprint_queue";
export const ROUTE_BODYPRINT_DECLINED = "bodyprint_declined";
export const ROUTE_BODYPRINT_EDIT = "bodpyrint_edit";
export const ROUTE_BODYPRINT_CHECK = "bodyprint_check";
export const ROUTE_BODYPRINT_BLUR_EDIT = "bodyprint_blur_edit";
export const ROUTE_BLUR_QUEUE = "blur_queue";
export const ROUTE_BLUR_EDIT = "blur_edit";
export const ROUTE_PRODUCTION = "production";
export const ROUTE_PRODUCTION_ORDER_CHECK = "production_order_check";
export const ROUTE_PRODUCTION_ORDER_EDIT = "production_order_edit";
export const ROUTE_SETTINGS = "settings";

const routes = [
  {
    path: "/healthz",
    name: ROUTE_HEALTH,
    component: {
      render(c) {
        return c("div", "OK");
      }
    }
  },
  {
    path: "/login",
    name: ROUTE_LOGIN,
    component: Login,
    meta: {
      auth: false
    }
  },
  {
    path: "/",
    name: ROUTE_INDEX,
    component: Index,
    meta: {
      auth: true
    }
  },
  {
    path: "/bodyprint",
    name: ROUTE_BODYPRINT_QUEUE,
    component: BodyprintQueueView,
    meta: {
      auth: true,
      type: "bodyprint"
    }
  },
  {
    path: "/bodyprint/declined",
    name: ROUTE_BODYPRINT_DECLINED,
    component: BodyprintDeclinedView,
    meta: {
      auth: true,
      type: "bodyprint"
    }
  },
  {
    path: "/bodyprint/edit/:queue_id",
    name: ROUTE_BODYPRINT_EDIT,
    component: BodyprintEditView,
    meta: {
      auth: true,
      type: "bodyprint"
    }
  },
  {
    path: "/bodyprint/check/:queue_id",
    name: ROUTE_BODYPRINT_CHECK,
    component: BodyprintCheckView,
    meta: {
      auth: true,
      type: "bodyprint"
    }
  },
  {
    path: "/bodyprint/blur/:queue_id",
    name: ROUTE_BODYPRINT_BLUR_EDIT,
    component: BlurEditView,
    meta: {
      auth: true,
      type: "bodyprint"
    }
  },
  {
    path: "/blur",
    name: ROUTE_BLUR_QUEUE,
    component: BlurQueueView,
    meta: {
      auth: true,
      type: "blur"
    }
  },
  {
    path: "/blur/:queue_id",
    name: ROUTE_BLUR_EDIT,
    component: BlurEditView,
    meta: {
      auth: true,
      type: "blur"
    }
  },
  {
    path: "/production",
    name: ROUTE_PRODUCTION,
    component: ProductionListView,
    meta: {
      auth: true,
      type: "production"
    }
  },
  {
    path: "/production/order/check/:order_id",
    name: ROUTE_PRODUCTION_ORDER_CHECK,
    component: ProductionOrderCheckView,
    meta: {
      auth: true,
      type: "production"
    }
  },
  {
    path: "/production/order/edit/:order_id",
    name: ROUTE_PRODUCTION_ORDER_EDIT,
    component: ProductionOrderEditView,
    meta: {
      auth: true,
      type: "production"
    }
  },
  {
    path: "/settings",
    name: ROUTE_SETTINGS,
    component: Settings,
    meta: {
      auth: true
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  store.dispatch("auth/authCheck").then(() => {
    const authenticated = store.state.auth.loggedIn;

    if (to.matched.length === 0) {
      if (authenticated) {
        store.dispatch("application/updateCurrentRoute", ROUTE_INDEX);
        next({ name: ROUTE_INDEX });
      } else {
        store.dispatch("application/updateCurrentRoute", ROUTE_LOGIN);
        next({ name: ROUTE_LOGIN });
      }
    }

    if (from.meta.type !== undefined && from.meta.type !== to.meta.type) {
      localStorage.removeItem("selectedQueueItem");
      localStorage.removeItem("selectedUser");
      localStorage.removeItem("filter");
    }

    if (to.matched.some(m => m.path === "/login") && authenticated) {
      store.dispatch("application/updateCurrentRoute", ROUTE_INDEX);
      next({ name: ROUTE_INDEX });
    } else if (to.matched.some(m => m.meta.auth) && !authenticated) {
      store.dispatch("application/updateCurrentRoute", ROUTE_LOGIN);
      next({ name: ROUTE_LOGIN });
    } else {
      store.dispatch("application/updateCurrentRoute", to.name);
      next();
    }
  });
});

export default router;
